import { html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './takeover-modal.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class Modal extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      isOpen: { type: Boolean },
      isWhite: { type: Boolean },
      forceTop: { type: Boolean },
      goBackArrow: { type: Boolean },
      noTrigger: { type: Boolean },
      expandContentsOnLarge: { type: Boolean },
      styleclass: { type: String },
    };
  }

  constructor() {
    super();
    this.isOpen = false;
    this.isWhite = false;
    this.forceTop = false;
    this.goBackArrow = false;
    this.noTrigger = false;
    this.expandContentsOnLarge = false;
  }

  toggleModal() {
    this.isOpen = !this.isOpen;
    this.requestUpdate('isOpen', this.isOpen);
  }

  render() {
    return html`
      ${!this.noTrigger
        ? html` <button
            role="button"
            title="trigger modal"
            @click="${this.toggleModal}"
            class="${classMap({
              'takeover-modal__trigger': true,
              'takeover-modal__trigger--hide-on-large':
                this.expandContentsOnLarge,
            })}"
          >
            <slot name="button_content"></slot>
          </button>`
        : nothing}

      <div
        class="${classMap({
          'takeover-modal': true,
          'takeover-modal--force-top': this.forceTop,
          'takeover-modal--open': this.isOpen,
          'takeover-modal--white': this.isWhite,
          'takeover-modal--show-on-large': this.expandContentsOnLarge,
          [`takeover-modal--${this.styleclass}`]: !!this.styleclass,
        })}"
      >
        <button
          role="button"
          title="close modal"
          @click="${this.toggleModal}"
          class="${classMap({
            'takeover-modal__close-button': true,
            'takeover-modal__close-button--arrow': this.goBackArrow,
            'takeover-modal__close-button--hide-on-large':
              this.expandContentsOnLarge,
          })}"
        >
          <hf-icon
            name="${this.goBackArrow ? 'chevron-left' : 'close'}"
          ></hf-icon>
        </button>

        <slot
          name="modal_content"
          class="${classMap({
            'takeover-modal__content': true,
            'takeover-modal__content--show-on-large':
              this.expandContentsOnLarge,
            [`takeover-modal__content--${this.styleclass}`]: !!this.styleclass,
          })}"
        ></slot>
      </div>
    `;
  }
}

customElements.define('hf-takeover-modal', Modal);
